import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ApiProvider } from './providers/ApiProvider'
import { AuthProvider } from './providers/AuthProvider'
import { router } from './router'
import './styles/index.css'

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<AuthProvider>
			<ApiProvider>
				<RouterProvider router={router} />
				<ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover theme="light" />
			</ApiProvider>
		</AuthProvider>
	</StrictMode>,
)
